import { Configs } from '@/config';
import type { AuthSession } from '@/auth/types';

export interface PostLogoutResult {
  serverRevoked: boolean;
}

/**
 * POST logout to coolture_auth and revoke the server session.
 */
export async function postLogout(session: AuthSession): Promise<PostLogoutResult> {
  if (!Configs.logoutApiUrl) {
    return { serverRevoked: false };
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${session.bearerToken}`,
  };

  try {
    const response = await fetch(Configs.logoutApiUrl, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({
        companyID: session.companyID,
        employeeID: session.employeeID,
      }),
    });

    if (response.ok || response.status === 401) {
      return { serverRevoked: true };
    }

    return { serverRevoked: false };
  } catch {
    return { serverRevoked: false };
  }
}
